import React, {ReactNode, SyntheticEvent} from 'react';
import classNames from "classnames";


import {MuiIconExternalProps} from "../icons/MuiIcon";


import {Tooltip} from "../Tooltip"

import './ContextMenuInlineItem.css';


export interface ContextMenuInlineItemProps {
    Icon: React.ComponentType<MuiIconExternalProps>;
    onClick: (event: SyntheticEvent) => boolean | undefined;
    isActive?: boolean;
    handleClose?: () => void;
    getTooltip:() => ReactNode,
    hotKey?: string,
}

export const ContextMenuInlineItem = (
    {
        isActive,
        handleClose,
        onClick,
        Icon,
        getTooltip,
        hotKey
    }: ContextMenuInlineItemProps
) => {
    return (
        <Tooltip title={getTooltip()} hotKeys={hotKey} isInBox={true} VERTICAL_SHIFT={6}>
            <Icon
                className={classNames({
                    'ContextMenuInlineItem': true,
                    'ContextMenuInlineItem--active': isActive,
                })}
                size={20}
                onClick={(e) => {
                    e.stopPropagation();
                    const clickResult = onClick(e);
                    if (clickResult !== false && handleClose) {
                        handleClose();
                    }
                }}
            />
        </Tooltip>
    )
}
